
export const environment_auth = {
  bypassLogin: false,

  openIdConnectClientId: '340f3a1b-5f18-484b-815c-0c7b2f198c00',
  openIdConnectConfigURL: 'https://login.microsoftonline.com/ef8a53ea-1a1c-4189-b792-c832dcaea568/v2.0/.well-known/openid-configuration',

  userInfoEndpoint: 'https://graph.microsoft.com/oidc/userinfo',
};
